import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';
import Annotation from '@/components/Annotation';
import { useRouter } from 'next/router';

const PageConPc = dynamic(() => import('@/components/productSmart/wave2/detail/indexDynamic'), {
    ssr: true,
});
export default function Wave2PC() {
    const { locale = 'us' } = useRouter();
    return (
        <div className={`wave2-pc ${css.wave2PC}`}>
            {!['us', 'ca'].includes(locale) && <A />}
            <PageConPc />
            <Annotation borderTopColor="transparent" bgColor="#000" product="WAVE 2" boxStyle={{ width: '1120px' }} />
        </div>
    );
}
